import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import VBox from 'components/common/VBox';
import HBox from 'components/common/HBox';

export default function SimulationResultInfo(props) {
  return (
    <VBox {...ex('SimulationResultInfo', props)}>
      <HBox>
        <HBox {...ex('SimBox')}>
          <VBox>
            <div>
              {T('AI 추천 시나리오를 준비 중이에요')}
            </div>
          </VBox>
        </HBox>
        <div>
          <svg width={28} height={28} viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_2725_3168)">
              <path d="M114 58C114 27.0721 88.9279 2 58 2C27.0721 2 2 27.0721 2 58C2 88.9279 27.0721 114 58 114H114V58Z" fill="url(#paint0_linear_2725_3168)" />
            </g>
            <ellipse cx="26.4364" cy="52.9091" rx="6.10909" ry="8.14545" fill="white" />
            <ellipse cx="24.4" cy="52.9089" rx="4.07273" ry="6.10909" fill="black" />
            <ellipse cx="46.8" cy="52.9091" rx="6.10909" ry="8.14545" fill="white" />
            <path d="M28.4727 69.1998C29.1515 70.8968 31.3236 74.2907 34.5818 74.2907C37.84 74.2907 40.6909 69.8786 41.7091 68.1816" stroke="black" strokeWidth={2} strokeLinecap="round" />
            <ellipse cx="44.7636" cy="52.9089" rx="4.07273" ry="6.10909" fill="black" />
            <defs>
              <filter id="filter0_d_2725_3168" x={0} y={0} width={120} height={120} filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dx={2} dy={2} />
                <feGaussianBlur stdDeviation={2} />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2725_3168" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2725_3168" result="shape" />
              </filter>
              <linearGradient id="paint0_linear_2725_3168" x1="21.3455" y1="15.2364" x2="116.036" y2="117.055" gradientUnits="userSpaceOnUse">
                <stop stopColor="#E8F0FF" />
                <stop offset={1} stopColor="#3B6FD1" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </HBox>

    </VBox>
  );
}
